import { Wealthlane_AppServices_Features_CompanyFeatureSetDto } from '@wealthlane/api-services/wealthlane-identity-service';

export interface FeatureSet {
  featureSetId: string;
  featureSetName: string;
  permissions: string[];
}

export interface OldPermissions {
  [key: string]: boolean;
}

export const convertPermissions = (
  newApiData: Wealthlane_AppServices_Features_CompanyFeatureSetDto[]
): OldPermissions => {
  const oldPermissionsFormat: OldPermissions = {};
  oldPermissionsFormat['tokens'] = true; // Include 'tokens': true as in the old data
  newApiData.forEach((featureSet) => {
    const permissionsList = featureSet.permissions || [];
    permissionsList.forEach((permission) => {
      oldPermissionsFormat[permission] = true;
    });
  });

  return oldPermissionsFormat;
};
export const convertDualPermissions = (newApiData: any[]): OldPermissions => {
  const oldPermissionsFormat: OldPermissions = {};
  oldPermissionsFormat['tokens'] = true; // Include 'tokens': true as in the old data
  newApiData.forEach((item) => {
    const key = typeof item === 'string' ? item : item?.permission;
    if (key) {
      oldPermissionsFormat[key] = true;
    }
  });

  return oldPermissionsFormat;
};
